import {Component, EventEmitter, Inject, Injector, Input, Output} from '@angular/core';
import {FormControl, FormGroup} from '@angular/forms';
import {FrontendFormComponent} from '@abstract/frontend.form.component';

/**
 * Форма изменения состояния сотрудника
 */
@Component({
    selector: 'app-status-change-form',
    template: `
        <form [formGroup]="form" (submit)="save(form)">
            <app-status-select [fbControl]="form.get('status')"></app-status-select>
            <app-button className="button-green" [pending]="isPending">
                <lib-icon type="save" [isInText]="true"></lib-icon>
                Сохранить
            </app-button>
        </form>
    `
})

export class StatusChangeFormComponent extends FrontendFormComponent {

    @Input() id: number;
    @Input() currentStatus: number;
    @Input() public afterSaveMessage;

    @Output() saveStatus = new EventEmitter();

    public form = new FormGroup({
        id: new FormControl(''),
        status: new FormControl(1)
    });

    constructor(
        injector: Injector,
        @Inject('StatusChangeService') public formService,
    ) {
        super(injector);
    }

    init() {
        this.form.get('id').patchValue(this.id);
        this.form.get('status').patchValue(this.currentStatus);
    }

    afterSave(): void {
        super.afterSave();
        this.isPending = false;

        this.saveStatus.emit(this.form.get('status').value);
    }
}
